export default __webpack_public_path__ + "static/code-toit-ed3089dce7507c5de105344598c6fc33.png";